<template>
  <div class="hello">
    <!-- 形象圖 -->
    <transition name="fade">
    <section class="main_section" v-bind:class="{ 'pic--2': slogan === 1 }">
      <div class="slogan" v-if="slogan === 1 && false">
        <span class="title">來趟小旅行一塊學英語！</span>
        <p class="desc">「新北市英語智慧城」提供創新型態的學習服務，透過熱門景點進行影音互動學習。和我們一起快樂玩，輕鬆學，走遍新北市景點，學好旅遊英語，收藏在地旅行的動人回憶。</p>
      </div>

      <div class="slogan2" v-if="slogan === 2 && false">
        <span class="title">新北市英語智慧城 APP</span>
        <p>新北市就是你的英語教室</p>
      </div>

      <div class="sloganPagination text-xs-center" v-if="false">
        <v-btn class="bg--primary" small floating v-on:click.native="sloganClick(1)">1</v-btn>
        <v-btn class="bg--primary" small floating v-on:click.native="sloganClick(2)">2</v-btn>
      </div>
    </section>
    </transition>

    <!-- 功能特色 -->
    <section class="pa-5 bg--white" id="anchor-1">
      <h4 class="title">功能特色</h4>
      <p class="desc">四大學習功能讓您邊玩邊學</p>

      <v-row class="text-xs-left">
        <v-col sm5 offset-sm1 pa-3>
          <v-row>
            <v-col xs3 class="text-xs-center">
              <img src="~../assets/images/icon_video.svg" />
            </v-col>
            <v-col xs9>
              <span class="sub-title">互動課程</span>
              <p>包含實用會話、影音簡介、圖解單字與學習任務等學習功能，想知道新北市哪裡好玩，想要身歷其境，現場即時學英語，請立刻下載，讓『新北市英語智慧城』 APP 陪你一起暢新北市英語智慧城。</p>
            </v-col>
          </v-row>
        </v-col>

        <v-col sm5 pa-3>
          <hr class="hidden-sm-and-up" style="margin-bottom: 1.5em;" />
          <v-row>
            <v-col xs3 class="text-xs-center">
              <img src="~../assets/images/icon_coin.svg" />
            </v-col>
            <v-col xs9>
              <span class="sub-title">暑假特別活動 / 來福幣兌換</span>
              <p>於暑假期間規劃了英語學習課程，讓學習者從問答中認識景點特色及相關英語，讓你邊玩邊學好英語，答對可獲得來福幣，還能兌換禮物哦！</p>
            </v-col>
          </v-row>
        </v-col>

        <v-col sm5 offset-sm1>
          <hr style="margin-bottom: 1.5em;" />
          <v-row>
            <v-col xs3 class="text-xs-center">
              <img src="~../assets/images/icon_location.svg" />
            </v-col>
            <v-col xs9>
              <span class="sub-title">GPS定位</span>
              <p>使用 GPS 定位快速找到鄰近的景點，跟著 APP 吃喝玩樂學英語，來趟不一樣的深度新北市之旅。</p>
            </v-col>
          </v-row>
        </v-col>

        <v-col sm5>
          <hr style="margin-bottom: 1.5em;" />
          <v-row>
            <v-col xs3 class="text-xs-center">
              <img src="~../assets/images/icon_ar.svg" />
            </v-col>
            <v-col xs9>
              <span class="sub-title">擴增實境</span>
              <p>採用創新擴增實境 (AR) 技術，進行打卡任務，連結景點場景，體驗浸潤式的英語學習樂趣。</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </section>

    <!-- 熱門景點 -->
    <section class="pa-5 bg--primary" id="anchor-2">
      <h4 class="title">熱門景點</h4>
      <p class="desc">最受歡迎的新北市熱門景點大推薦</p>

      <v-row class="text-xs-left">
        <v-col sm3>
          <img src="~../assets/images/p_01.png" width="100%" />
          <span class="sub-title">九份老街</span>
          <p>九份老街為基山街，昔日稱為「暗街仔」，為九份主要街道，商店林立。在九份的巷弄中，可以多走樓梯，隨處繞繞，逛逛各式各樣的特色小店，發現九份山城之美。</p>
        </v-col>
        <v-col sm3>
          <img src="~../assets/images/p_02.png" width="100%" />
          <span class="sub-title">深坑老街</span>
          <p>深坑，一個距離有點遠又不太遠的遠離市區商圈，是個半日遊的好選擇! 因為清澈的水質以及特殊鹽滷製法所製作的豆腐，其炭味口感吸引了許多饕客，成為一般人熟知的「豆腐故鄉」，也因此造就了老街的繁榮。</p>
        </v-col>
        <v-col sm3>
          <img src="~../assets/images/p_04.png" width="100%" />
          <span class="sub-title">黃金博物館</span>
          <p>黃金博物館是國內首座以礦業文化保存為宗旨的公立博物館，建館之初即以生態博物館為理念規劃，將礦業文化保存與再現，歡迎一同體驗與發現金瓜石特殊的自然生態以及歷史人文之美。</p>
        </v-col>
        <v-col sm3>
          <img src="~../assets/images/p_03.png" width="100%" />
          <span class="sub-title">朱銘美術館</span>
          <p>台灣當代雕塑大師「朱銘」選在有好山好水的金山地區，規劃出佔地11公頃的藝術公園，依據不同地貌呈現他不同時期的重要創作。很適合親子家庭到訪，同時滿足孩子的藝術體驗、看表演、玩樂、用餐等多方面需求。</p>
        </v-col>
      </v-row>

      <h5 style="color: #fff;">
        <span style="border-bottom: 1px solid #fff; cursor: pointer;" @click="$router.push({ name: 'Places' })">景點列表</span>
      </h5>
    </section>

    <!-- 下載方式 -->
    <section class="pa-5 bg--white" id="anchor-3">
      <h4 class="title">下載方式</h4>
      <p class="desc">這麼酷的APP還不快下載</p>

      <v-row class="pa-3">
        <v-col xs12 offset-sm3 sm3>
          <a href="https://itunes.apple.com/tw/app/%E6%96%B0%E5%8C%97%E5%B8%82%E8%8B%B1%E8%AA%9E%E6%99%BA%E6%85%A7%E5%9F%8E/id1337959562?mt=8" target="_blank">
            <img src="~../assets/images/icon_02.png" />
          </a>
        </v-col>
        <v-col xs12 sm3>
          <a href="https://play.google.com/store/apps/details?id=com.liveabc.ntc4g" target="_blank">
            <img src="~../assets/images/icon_03.png" />
          </a>
        </v-col>
      </v-row>

      <v-row class="mt-3 text-xs-left" v-if="false">
        <v-col offset-sm1 sm5>
          <div class="ma-4 pb-4" style="min-height: 9em;">
            <span class="sub-title">Step 1 免費註冊</span>
            <p>下載並開啟『新北市英語智慧城』 APP，完成 LiveABC 會員註冊程序，即可免費獲得「國立臺灣美術館」課程，前往景點學習。</p>
          </div>

          <hr />

          <div class="ma-4 pb-4" style="min-height: 9em;">
            <span class="sub-title">Step 2 進入課程</span>
            <p>購買悠活30方案或暢遊365方案，進入學習課程。透過 GPS 定位，開啟互動影音課程，體驗浸潤式的英語學習樂趣。</p>
          </div>

          <hr class="hidden-sm-and-up"  />
        </v-col>
        <v-col sm5>
          <div class="ma-4" style="min-height: 9em;">
            <span class="sub-title">Step 3 挑戰任務</span>
            <p>課程中安排了許多英語學習任務，透過 GPS 定位及 AR 擴增實境，解鎖景點，從生活場域中發現你所看的聽的都是英文，答對了可立即獲得獎勵來福幣。</p>
          </div>

          <hr />

          <div class="ma-4 pb-4" style="min-height: 9em;">
            <span class="sub-title">Step 4 兌換好禮</span>
            <p>獎勵來福幣達指定數量時，即有機會兌換 LiveABC 提供的學習禮物，實際兌換禮物依網站公告為準。</p>
          </div>
        </v-col>
      </v-row>
    </section>

    <!-- 購買方案 -->
    <section class="pa-5" id="anchor-4">
      <h4 class="primary-color title">購買方案</h4>
      <p class="primary-color desc">選擇適合您的旅遊學習方式，跟著我們走到哪學到哪。</p>
      <br>
      <span style="background-color: #fff; color: red; padding: 1em;">即日起 ~ 2018/10/31 限時免費使用</span>

      <v-row class="ma-3 mt-5 text-xs-center average">
        <v-col xs12 sm3 class="ma-3 pa-5 bg--light">
          <span class="sub-title">體驗方案</span><br />
          90天<br />定價 199元<br />
        </v-col>

        <v-col xs12 sm3 class="ma-3 pa-5 bg--light">
          <span class="sub-title">暢遊方案</span><br />
          365天<br /> 定價 699元<br />
        </v-col>
      </v-row>

      <p class="primary-color mt-5">小編提醒：建議搭配4G行動上網方案體驗「遊新北學英語」景點課程，確保學習服務順暢。</p>
    </section>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'

  export default {

    name: 'hello',

    data () {
      return {
        slogan: 1,
        intervalId: null
      }
    },

    created () {
      this.initBreadcrumb()
      this.addBreadcrumb({
        text: '首頁',
        link: '/'
      })

      // this.mainSectionSwitcher()
    },

    beforeDestroy () {
      clearInterval(this.intervalId)
      this.intervalId = null
    },

    methods: {
      ...mapMutations([
        'addBreadcrumb',
        'initBreadcrumb'
      ]),

      mainSectionSwitcher () {
        var self = this

        if (this.intervalId !== null) {
          clearInterval(this.intervalId)
        }

        this.intervalId = setInterval(() => {
          self.slogan = self.slogan === 1 ? 2 : 1
        }, 5000)
      },

      sloganClick (num) {
        this.slogan = num
        this.mainSectionSwitcher()
      }
    }
  }
</script>

<style lang="scss" scoped>
  section {
    position: relative;
    text-align: center;
    color: #fff;

    .title {
      font-weight: 900;
      font-size: 2em;
    }

    .sub-title {
      font-weight: 900;
      font-size: 1.3em;
      line-height: 200%;
    }

    &.bg--primary,
    .bg--primary {
      background-color: #4a4a66 !important;
      color: #fff !important;
      h4 {
        color: #fff !important;
      }
    }

    &.bg--white,
    .bg--white {
      background-color: #fff !important;
      color: #4a4a66 !important;
      h4 {
        color: #4a4a66 !important;
      }
    }

    &.bg--light,
    .bg--light {
      background-color: #8268b0 !important;
      color: #fff !important;
      h4 {
        color: #fff !important;
      }
    }

    &.main_section {
      height: 70vh;

      .slogan {
        background-color: white;
        width: 50vh;
        max-height: 100vh;
        position: absolute;
        left: 0;
        top: 30%;
        padding: 2em;

        .title {
          color: #4a4a66 !important;
          font-size: 2em;
          font-weight: 900;
        }

        .desc {
          margin-top: 1em;
          color: #4a4a66 !important;
          text-align: left;
        }
      }

      .slogan2 {
        width: 100%;
        height: 25vh;
        position: absolute;
        top: 20%;
        padding: 2em;
        text-align: center;
        color: #4a4a66;
        font-size: 1.6em;
        color: #8268b0 !important;

        .title {
          font-size: 2em;
          font-weight: 900;
        }

        p {
          letter-spacing: 0.6em;
        }
      }

      .sloganPagination {
        position: absolute;
        bottom: 1.5em;
        width: 100%;

        .bg--primary {
          width: 2em;
          height: 2em;
          padding: 0;
        }
      }
    }

    @media screen and (min-width: 768px) {
      .average {
        .col:first-child {
          margin-left: auto !important;
        }

        .col:last-child {
          margin-right: auto !important;
        }
      }
    }
  }

  .main_section {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;

    &.pic--2 {
      background-image: url('~../assets/images/m_01.jpg');
    }
  }
</style>



// WEBPACK FOOTER //
// Hello.vue?5918dc99